import { Col, Row, Container } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { selectUser, selectAuthStatus } from '../../../selectors/users'
import { useLogoutMutation } from '../../../services/auth_endpoints'
import { Footer } from '../footer'
import { LoggedOutDropdown } from './logged_out_dropdown'
import { LoggedInDropdown } from './logged_in_dropdown'
import { HamburgerDropdown } from './hamburger_dropdown'
import { LanguageSwitcher } from '../../shared/language_switcher'
import IconButton from '../../shared/icon_button'
import { ImpersonationBanner } from '../../shared/impersonation_banner'
import { WHITE_LOGO_URL } from '../../../assets_config'
import SimpleBar from 'simplebar-react'

export const Header = ({children}) => {

  const { t } = useTranslation()
  const user = useSelector(selectUser);
  const authStatus = useSelector(selectAuthStatus)

  const [logout] = useLogoutMutation()

  const handleLogout = async (event) => {
    event.preventDefault()
    await logout()
    window.location.href = '/'
  }

  return (
    <>
      <SimpleBar style={{ height: '100vh' }}>
        <ImpersonationBanner />
        <div className="page-wrapper">
          <Container fluid>
            <Row className="header-container">
              <Col md={4} xs={4} className="center-content-v">
                <div className="left-content margin-left-1 inline-flex-container">
                  <HamburgerDropdown />
                  <LanguageSwitcher />
                </div>
              </Col>
              <Col md={4} xs={4} className="center-content">
                <a className="header-link" href="/">
                  <img
                    alt="top-spin-logo"
                    src={WHITE_LOGO_URL}
                    className="logo"
                    fetchpriority="high"
                    width={120}
                    height={40}
                  />
                </a>
              </Col>
              <Col md={{ span: 1, offset: 3 }} xs={4} className="center-content-v">
                <div className="right-content margin-right-1">
                  {authStatus === 'authenticated' && (
                    <LoggedInDropdown user={user} handleLogout={handleLogout} />
                  )}
                  {authStatus === 'anonymous' && <LoggedOutDropdown />}
                  {authStatus === 'loading' && (
                    // /me still in flight: render a stable, neutral icon so the
                    // widget doesn't flash logged-out contents before it resolves.
                    <IconButton icon='user' width={36} height={36} tooltip={t('userMenu.accountMenuTooltip')} disabled />
                  )}
                </div>
              </Col>
            </Row>
          </Container>

          <div className="content-wrapper">{children}</div>

          <Footer />
        </div>
      </SimpleBar>
    </>
  )
}
